import { Box, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const InfoViewDetailsContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? COLORS.CARD_LIGHT_GRAY : COLORS.WHITE,
  display: 'grid',
  gap: '10px',
  borderRadius: '8px',
  border: theme.palette.type === 'dark' ? 'unset' : `1px solid ${COLORS.LIGHT_BORDER}`,
  padding: '20px',
}));

export const InfoViewDetailsItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));
